import Content from '@components/Content'
import { FC } from 'react'
import styles from './Separator.module.scss'

export const Separator: FC<{ separator: boolean }> = () => (
  <Content>
    <div className={styles.separator}></div>
  </Content>
)
